import { render, staticRenderFns } from "./avaliar-list.vue?vue&type=template&id=74d89929&"
import script from "./avaliar-list.vue?vue&type=script&lang=js&"
export * from "./avaliar-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports